module.exports = __webpack_public_path__ + "img/camera_lock.1314810a.svg";